<template>
    <div class="gmf-image-list-input">
        <div v-for="file in files" :key="file.key" class="gmf-image-list-input-cell gmf-image-list-input-image" :style="{
            backgroundImage: 'url(' + file.preview + ')',
        }">
            <div class="gmf-image-list-input-cell-remove" @click="removeFile(file)"> ✕ </div>
        </div>

        <div class="gmf-image-list-input-add gmf-image-list-input-cell" v-if="files.length < maxFiles">
            <Icon icon="upload" />
            <div class="gmf-image-list-input-add-text gmf-text-small">
                {{ files.length }} / {{ maxFiles }}
            </div>
            <label>
                <input type="file" multiple accept="image/png, image/jpeg" @change="uploadFile" ref="fileInput" />
            </label>
        </div>
    </div>
</template>

<style>
.gmf-image-list-input {
    display: flex;
    flex-direction: row;
    gap: var(--gmf-p-3);
    flex-wrap: wrap;
}

.gmf-image-list-input label {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
    overflow: hidden;
}

.gmf-image-list-input input {
    opacity: 0;
    width: 100%;
    height: 100%;
    display: block;
    cursor: pointer;
    font-size: 0 !important;
    text-indent: -100px !important;
}

.gmf-image-list-input-cell {
    width: 80px;
    height: 80px;
    background: var(--gmf-input-bg);
    border-radius: var(--gmf-rounding);
    position: relative;
}

.gmf-context .gmf-image-list-input-cell-remove {
    background: var(--gmf-col-nearblack);
    position: absolute;
    top: -5px;
    right: -5px;
    border-radius: 99px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    vertical-align: middle;
    color: var(--gmf-col-white) !important;
    cursor: pointer;
}

.gmf-context .gmf-image-list-input-cell-remove:hover {
    background: var(--gmf-col-error);
}

.gmf-image-list-input-image {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    border: 2px solid var(--gmf-col-white);
    box-shadow: 0px 1px 2px rgba(0, 0, 0, .15);
}

.gmf-image-list-input-add {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.gmf-image-list-input-add .gmf-icon {
    width: 32px;
    height: 32px;
}
</style>

<script>
import Icon from '@/components/Icon.vue';


function hashCode(str) {
    var hash = 0,
        i,
        chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}


export default {
    props: {
        modelValue: {
            type: Array,
            default: () => [],
        },
        maxFiles: {
            type: Number,
            default: 5,
        },
    },
    components: {
        Icon,
    },
    data() {
        return {
            files: this.modelValue || [],
        };
    },
    methods: {
        removeFile(file) {
            let idx = this.files.indexOf(file);
            if (idx >= 0) {
                this.files.splice(idx, 1);
            }
            this.$emit("update:modelValue", this.files);
        },
        uploadFile(ev) {
            for (const file of ev.target.files) {
                if (this.files.length >= this.maxFiles) {
                    continue;
                }
                this.files.push({
                    key: hashCode(
                        file.name +
                        "-" +
                        file.size +
                        "-" +
                        file.type +
                        "-" +
                        file.lastModified
                    ),
                    preview: URL.createObjectURL(file),
                    file,
                });
            }
            this.$refs.fileInput.value = "";
            this.$emit("update:modelValue", this.files);
        },
    },
}
</script>
